export default __webpack_public_path__ + "static/media/word.da417892.png";